import attributeSets from './page/attributeSets/en';
import attributeKeys from './page/attributeKeys/en';
import limitProduct from './page/limitProduct/en';
import banner from './page/banner/en';
import categories from './page/categories/en';
import login from './page/login/en';
import products from './page/products/en';
import searchSynonims from './page/searchSynonims/en';
import users from './page/users/en';
import productLabels from './page/productLabels/en';
import twofactor from './page/twofactor/en';
import modalMediaLibrary from './components/modalMediaLibrary/en';
import manageFilter from './components/manageFilter/en';
import global from './global/en';
import register from './page/register/en';

export default {
	page: {
		attributeSets,
		attributeKeys,
		banner,
		categories,
		login,
		products,
		searchSynonims,
		users,
		productLabels,
		limitProduct,
		register,
		twofactor,
	},
	components: {
		modalMediaLibrary,
		manageFilter,
	},
	global,
};
